<template>
	<div class="demo-input-suffix">

		<img class="bgiss" src="../assets/images/bgc1.png" alt="">
		<el-container>
			<!-- TAB栏 -->
			<el-header>
				<div class="Left">
				</div>
				<div class="Right" @click="returns">
					<span class="iconfont">&#xe641;</span>
					<span class="iconHome">返回首页</span>
				</div>
			</el-header>

			<!-- 内容 -->

			<el-main>
				<div class="bgc">
					<img src="../assets/images/logos.png" alt="">
					<!-- 登陆表单区 -->
					<el-form label-width="0px" class="login_form">
						<el-input v-model="number"></el-input>
						<el-button type="primary" @click="onLogin" @blur="onBlurInput()">登录</el-button>
						<el-button @click="Reset">模拟考试</el-button>
					</el-form>
				</div>
			</el-main>
		</el-container>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				number: '',
				curriculum: []
			};
		},
		created() {},
		methods: {

			async sadsad() {
				// const {
				// 	data: res
				// } = await this.$http.get('ksChoice');
				// console.log(res);
				// this.curriculum = res[0].state
			},

			async onLogin() {
				// this.sadsad()
				const {
					data: res
				} = await this.$http.post("loginNumber", {
					number: Number(this.number)
				});
				console.log('res==>', res)
				setTimeout(() => {
					if (res.status !== 200) {
						this.$message.error('没有该预约，请进行预约!')
					} else if (res.data.datas[0].switchs === false) {
						this.$message.error('该账号被冻结，请联系管理员!')
					} else {
						this.curriculum = res.data.datas[0].curriculum
						console.log('this.curriculum:  ', this.curriculum)
						
						window.sessionStorage.setItem("token", res.token)
						localStorage.setItem("userInfo", JSON.stringify({
							number: this.number,
							username: res.data.datas[0].username,
							curriculum: this.curriculum
						}));
						if (window.sessionStorage.getItem('token')) {
							this.$router.push({
								path: "/test",
								query: {
									number: this.number,
									username: res.data.datas[0].username,
									curriculum: this.curriculum
								}
							});
						}
					}
				}, 300);
			},

			Reset() {
				// this.number = ''
				this.$router.push("/mon");
			},

			// 返回
			returns() {
				window.sessionStorage.clear();
				localStorage.removeItem("userInfo");
				this.$router.push("/home");
			},
			onBlurInput() {
				window.scroll(0, 0)
			}
		}
	};
</script>

<style lang="less" scoped>
	.bgiss {
		width: 100%;
		height: 100%;
		position: fixed;
		z-index: -99;
	}

	.logbgc {
		position: absolute;
		width: 900px;
		top: 30%;
		left: 10%;
	}

	.el-main {
		display: flex;
		justify-content: flex-end;
		height: 100%;
	}

	.el-main .bgc {
		width: 400px;
		margin-right: 4rem;
		margin-top: 7.5%;
		position: relative;
	}

	.bgc img {
		width: 100%;
	}

	.el-header p {
		color: #fff;
		margin: 0 auto;
		font-size: 2em;
		font-weight: 600;
	}

	.el-header span {
		display: block;
	}

	.el-header .logoh1 {
		font-size: 1em;
		font-weight: 400;
		margin-left: 0.1875rem;
		margin-top: -0.25rem;
	}

	.el-header {
		margin: 1.25rem 0;
		margin-left: 8.75rem;
		display: flex;
		justify-content: space-between;
		margin-top: 5%;
	}

	.Right {
		margin-right: 6.25rem;
		margin-top: -1.0625rem;
	}

	.iconHome {
		font-size: 22px;
		color: #fff;
	}

	.iconfont {
		font-size: 50px;
		color: #fff;
		padding-left: 16px;
	}

	.el-input {
		text-align: center;
		margin-bottom: 50px;
	}

	/deep/.el-input__inner {
		text-align: center;
		width: 79%;
		border-radius: 3px;
		font-size: 20px;
		height: 50px;
	}

	/deep/.el-button--primary {
		margin-left: 45px;
	}

	.login_form {
		position: absolute;
		bottom: 7%;
		width: 69%;
		left: 52px;
	}
</style>
